import { Instagram, Facebook, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const linkCls = "text-muted-foreground hover:text-primary transition-colors rounded-md px-2 py-1 -ml-2 inline-block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background";

  return (
    <footer className="py-12 border-t border-border" role="contentinfo">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-1">
            <Logo />
            <p className="mt-4 text-sm text-muted-foreground">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">{t("footer.servicesTitle")}</h4>
            <nav><ul className="space-y-2 text-sm">
              <li><Link to="/accompagnement" className={linkCls}>{t("footer.accompagnement")}</Link></li>
              <li><Link to="/services" className={linkCls}>{t("footer.ourServices")}</Link></li>
              <li><Link to="/tarifs" className={linkCls}>{t("footer.pricing")}</Link></li>
            </ul></nav>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">{t("footer.guidesTitle")}</h4>
            <nav><ul className="space-y-2 text-sm">
              <li><Link to="/articles/marketing-de-contenu-b2b-quebec-guide-complet" className={linkCls}>{t("footer.guideB2B")}</Link></li>
              <li><Link to="/articles/creation-de-contenu-entreprises-guide-b2b-quebec" className={linkCls}>{t("footer.guideCreation")}</Link></li>
              <li><Link to="/articles/agence-marketing-b2b-quebec-choisir-partenaire" className={linkCls}>{t("footer.guideAgency")}</Link></li>
              <li><Link to="/articles/marketing-video-b2b-vendre-positionner" className={linkCls}>{t("footer.guideVideo")}</Link></li>
              <li><Link to="/articles" className={linkCls}>{t("footer.allArticles")}</Link></li>
            </ul></nav>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">{t("footer.followTitle")}</h4>
            <nav>
              <div className="flex items-center gap-4">
                <a href="https://www.instagram.com/agence.8020/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors p-2 rounded-lg hover:bg-secondary" aria-label="Instagram"><Instagram className="w-5 h-5" /></a>
                <a href="https://www.facebook.com/profile.php?id=61582833982758" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors p-2 rounded-lg hover:bg-secondary" aria-label="Facebook"><Facebook className="w-5 h-5" /></a>
                <a href="https://youtube.com/@agence8020" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors p-2 rounded-lg hover:bg-secondary" aria-label="YouTube"><Youtube className="w-5 h-5" /></a>
              </div>
            </nav>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <nav>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <Link to="/politique-confidentialite" className="hover:text-primary transition-colors rounded-md px-2 py-1 -ml-2">{t("footer.privacy")}</Link>
            </div>
          </nav>
          <span className="text-sm text-muted-foreground">© {currentYear} Agence 8020. {t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
